import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { firstOrgSettingsLink } from '../pages/org-settings/org-settings-nav';

export const orgSettingsGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.canAccessOrgSettings()) {
    return true;
  }
  return router.createUrlTree(['/app/chat']);
};

export const orgSettingsHomeGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const link = firstOrgSettingsLink((key) => auth.hasPermission(key));
  if (!link) {
    return router.createUrlTree(['/app/chat']);
  }
  return router.parseUrl(link);
};

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permission = route.data['permission'] as string | undefined;
  const permissions = (route.data['permissions'] as string[] | undefined) ?? (permission ? [permission] : []);
  if (permissions.length && !permissions.every((key) => auth.hasPermission(key))) {
    const fallback = firstOrgSettingsLink((key) => auth.hasPermission(key));
    return router.parseUrl(fallback ?? '/app/chat');
  }
  return true;
};
